import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";
import BirthdatePicker from "@/common/customer.additional-data-fields/BirthdatePicker";
import PostcodePicker from "@/common/customer.additional-data-fields/PostcodePicker";
import LanguagePicker from "@/common/customer.additional-data-fields/LanguagePicker";
import RequirePassword from "@/common/customer.additional-data-fields/RequirePassword";
import SaveButton from "@/common/customer.additional-data-fields/SaveButton";
import {getPlatform} from "@/hooks";

const {
    Customer,
    UI
} = Mobi2Go;

const { requestCreateDataCandyAccount } = Customer.DataCandyLoyalty;

const DataCandy = ({
    closeModal,
    baseClass,
    t,
    loyalty,
    birthdate,
    postcode,
    setBirthdate,
    setPostcode,
}) => {
    const [language, setLanguage] = useState('');
    const [password, setPassword] = useState('');
    const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(true);
    const [savedCards, setSavedCards] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isCustomerLoyalty, setIsCustomerLoyalty] = useState(false);

    useEffect(() => {
        setSavedCards(loyalty?.state?.linked_card !== null ? loyalty.state.linked_cards : []);
        setIsCustomerLoyalty(loyalty?.state?.profile_id !== null);
        setLanguage(Customer.getLanguage());
    })

    useEffect(() => {
        if (password && birthdate && postcode && language) {
            setIsSaveButtonDisabled(false);
        } else {
            setIsSaveButtonDisabled(true);
        }
    }, [password])

    const saveToServer = () => {
        Customer.update({
            date_of_birth: birthdate,
            post_code: postcode,
            language
        }, (status, error) => {
            if (status === 'error' && error) {
                throw error;
            }
        })
    }

    const onSave = async (e) => {
        e.preventDefault();
        setIsSaveButtonDisabled(true);
        setIsLoading(true);

        try {
            saveToServer();

            if (!isCustomerLoyalty) {
                await requestCreateDataCandyAccount({
                    email: Customer.getEmail(),
                    language,
                    name: Customer.getName(),
                    dob: birthdate,
                    phone: Customer.getPhoneNumber(),
                    postcode,
                    password
                });
            }

            setIsLoading(false);
            setPassword('');

            if (getPlatform() === 'web') {
                closeModal();
            } else {
                UI.page.change('main');
            }
        } catch (err) {
            setIsLoading(false);
            setPassword('');

            throw err;
        }
    }

    // If a customer does not have a saved card do not show this component, as they cannot create a loyalty account
    if (savedCards?.length === 0) {
        return null;
    }

    return (
        <>
            <BirthdatePicker
                handleChange={setBirthdate}
                baseClass={baseClass}
                birthdate={birthdate}
            />

            <PostcodePicker
                handleChange={setPostcode}
                baseClass={baseClass}
                postcode={postcode}
                t={t}
            />

            <LanguagePicker
                handleChange={setLanguage}
                baseClass={baseClass}
                language={language}
            />

            <RequirePassword
                handleChange={setPassword}
                baseClass={baseClass}
                password={password}
                isRefreshing={isLoading}
                promptText={t('password_prompt')}
                savingText={t('password_prompt_create_account')}
            />

            <SaveButton
                handleSave={onSave}
                baseClass={baseClass}
                saveButtonDisabled={isSaveButtonDisabled}
                text={t('save')}
            />
        </>
    );
}

DataCandy.defaultProps = {
    closeModal: () => null,
}

DataCandy.propTypes = {
    closeModal: PropTypes.func,
    formatDate: PropTypes.func.isRequired,
    baseClass: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    loyalty: PropTypes.object.isRequired,
    birthdate: PropTypes.string.isRequired,
    postcode: PropTypes.string.isRequired,
    setBirthdate: PropTypes.func.isRequired,
    setPostcode: PropTypes.func.isRequired,
}

export default DataCandy;
